import { useCallback} from 'react';
import jwtAuthStore from 'shared/store/jwtAuthStore';
import { isKnownHost } from 'shared/config/firebase';
import JwtAuthService from 'shared/services/JwtAuthService';

export const useJwtAuth = () => {
  // Get state from the store
  const {
    jwtToken,
    isJwtAuthenticated,
    isVerified,
    isInKnownHost,
    shouldUseJwt
  } = jwtAuthStore();
  
  // Function to check JWT token
  const verifyToken = useCallback(async (token: string) => {
    return await JwtAuthService.verifyToken(token);
  }, []);
  
  // Function to initialize JWT from URL
  const initializeFromUrl = useCallback(async () => {
    return await JwtAuthService.initializeFromUrl();
  }, []);
  
  // Function to get the current token (if authenticated)
  const getToken = useCallback(() => {
    return JwtAuthService.getToken();
  }, []);
  
  // Function to clear JWT authentication
  const clearAuth = useCallback(() => {
    JwtAuthService.clearAuth();
  }, []);
  
  // Check if the host is a known host (for immediate use without accessing store)
  const currentHostIsKnown = isKnownHost();
  
  return {
    // State
    jwtToken,
    isJwtAuthenticated,
    isVerified,
    isInKnownHost,
    shouldUseJwt,
    currentHostIsKnown,
    
    // Actions
    verifyToken,
    initializeFromUrl,
    getToken,
    clearAuth,
  };
}; 